export enum ModelType {
    POINT = 'point',
    QUEST = 'quest'
}

export const POINT = 'point'
export const QUEST = 'quest'